import React from 'react';
import { Helmet } from 'react-helmet';
import AppAnalytics from '../common/AppAnalytics';
import GlobalScrollbar from '@lexus.com/ui/dist/components/GlobalScrollbar';
import Ensighten from '@lexus.com/ui/dist/components/Ensighten';
import env from '@lexus.com/ui/dist/utilities/env';
import parseAnalytics from '../../utils/parse-analytics-tags';
import temporaryAnalytics from './temporaryAnalytics';

const ReactTemplate = ({ children, ...props }) => {
  const {
    pageTitle,
    description,
    pageTags = [],
    analyticsTags = [],
  } = props?.cqItems?.head || {};
  const analyticsValues = {
    app: 'L',
    hasLoaded: true,
    ...temporaryAnalytics(pageTitle),
    ...parseAnalytics(pageTags),
    ...parseAnalytics(analyticsTags),
  };

  return (
    <AppAnalytics {...analyticsValues}>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={description} />
        <meta property="cq:pagemodel_router" content="disabled" />
      </Helmet>
      <GlobalScrollbar />
      <Ensighten shareUrl={env('REACT_APP_LEXUS_SHARE')} ensightenUrl={env('REACT_APP_ENSIGHTEN_URL')} />
      {children}
    </AppAnalytics>
  );
};

export default ReactTemplate;
